export default {
  SampleOnly: 0, 
  SampleOnlyCapped: 1,
  SampleOrForecast: 2,
  SampleOrForecastCapped: 3
};